(function () {
  function triggerNativeUpdate(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    var form = el.closest('form');
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.inline-filter-strip--sidebar .inline-filter-strip__btn');
    if (!btn) return;
    e.preventDefault();

    var strip = btn.closest('.inline-filter-strip--sidebar');
    var gte = strip.querySelector('.js-engagement-price-gte');
    var lte = strip.querySelector('.js-engagement-price-lte');
    if (!gte || !lte) return;

    var min = btn.getAttribute('data-price-min') || '';
    var max = btn.getAttribute('data-price-max') || '';
    var isActive = btn.classList.contains('is-active');

    if (isActive) {
      // click the active one again to clear price filter
      gte.value = '';
      lte.value = '';
    } else {
      gte.value = (min === '0') ? '' : min; // "Below" -> no lower bound
      lte.value = max;
    }

    // instant visual feedback before the AJAX re-render
    strip.querySelectorAll('.inline-filter-strip__btn')
      .forEach(function (b) { b.classList.remove('is-active'); });
    if (!isActive) btn.classList.add('is-active');

    triggerNativeUpdate(lte);
  });
})();